<template>
  <transition name="modal" appear>
    <div class="modal modal-overlay" @click.self="$emit('close')">
      <div class="modal-window">
        <div class="modal-content">
          <section class="list-box white-box row">
            <h2 class="modal-title">パスワード管理</h2>
            <form>
              <table class="register-table-pass">
                <tr>
                  <th class="util-width-40">新しいパスワード</th>
                    <td>
                      <input :type="inputType1" v-model="newPassword" name="newPassword" class="input-pass" @change="checkPassword()">
                        <span class="input-icon-new-pass">
                          <span :class="iconType1" @click="onClick1"><img class="password-icon" src="../../static/icon_login.png"></span>
                        </span>
                      <div v-if="isCheckPassword && !$v.newPassword.required" class="text-error util-line-height-one"><small>パスワードを入力してください。</small></div>
                      <div v-if="(isCheckPassword && !$v.newPassword.minLength) || error" class="text-error util-line-height-one"><small>パスワードは6桁以上の半角英数字でお願いします。</small></div>
                    </td>
                </tr>
                <tr>
                  <th>新しいパスワード(確認)</th>
                  <td>
                    <input :type="inputType2" v-model="newPasswordConfirm" name="newPasswordConfirm" class="input-pass" @change="checkPasswordConfirm()">
                      <span class="input-icon-new-pass">
                        <span :class="iconType2" @click="onClick2"><img class="password-icon" src="../../static/icon_login.png"></span>
                      </span>
                    <div v-if="isCheckPasswordConfirm && !$v.newPasswordConfirm.sameAsNewPassword" class="text-error util-line-height-one"><small>新しいパスワードと新しいパスワード(確認)は一致させてください。</small></div>
                  </td>
                </tr>
              </table>
              <div class="modal-btn">
                <span class="btn-gray2"><button @click.prevent="$emit('close')">キャンセル</button></span>
                <span class="btn-gray2"><button @click.prevent="changePasswordBtnClick()">登録する</button></span>
              </div>
            </form>
          </section>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import httpResource from '../http/httpResource'
import store from '../store/index'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
export default {
  props: ['user'],
  data () {
    return {
      error: false,
      isCheckPassword: false,
      isCheckPasswordConfirm: false,
      newPassword: null,
      newPasswordConfirm: null,
      isChecked1: false,
      isChecked2: false
    }
  },
  validations: {
    newPassword: {
      required,
      minLength: minLength(6)
    },
    newPasswordConfirm: {
      sameAsNewPassword: sameAs('newPassword')
    }
  },
  computed: {
    inputType1: function () {
      return this.isChecked1 ? 'text' : 'password'
    },
    iconType1: function () {
      return this.isChecked1 ? 'eye' : 'eye-slash'
    },
    inputType2: function () {
      return this.isChecked2 ? 'text' : 'password'
    },
    iconType2: function () {
      return this.isChecked2 ? 'eye' : 'eye-slash'
    }
  },
  methods: {
    async changePasswordBtnClick () {
      // stop here if form is invalid
      this.checkPassword()
      this.checkPasswordConfirm()
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      const userChangePasswordForm = {
        userId: this.user.id,
        newPassword: this.newPassword,
        newPasswordConfirm: this.newPasswordConfirm
      }
      try {
        const response = await httpResource.post('/corporation/users/change-password', userChangePasswordForm, {headers: {Authorization: `Bearer ${store.getters.getAuthData.token}`}})
        if (response.status === 200) {
          this.$emit('close')
        }
      } catch (error) {
        this.error = true
      }
    },
    onClick1 () {
      this.isChecked1 = !this.isChecked1
    },
    onClick2 () {
      this.isChecked2 = !this.isChecked2
    },
    checkPassword () {
      this.error = false
      this.isCheckPassword = false
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.isCheckPassword = true
      }
      if (this.newPasswordConfirm !== null && this.newPasswordConfirm.length !== 0) {
        this.checkPasswordConfirm()
      }
    },
    checkPasswordConfirm () {
      this.isCheckPasswordConfirm = false
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.isCheckPasswordConfirm = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ChangeUserPassword.vue